/**
 * Formats a RUT (Rol Único Tributario)
 * Example: 764156536 -> 76.415.653-6
 * @param {string} rut
 * @returns {string} Formatted RUT
 */
export const formatRut = (rut) => {
    if (!rut) return '';

    // Clean data: remove non alphanumeric
    let value = rut.replace(/[^0-9kK]/g, '');

    // Return empty if no valid chars
    if (value.length === 0) return '';

    // Separate body and dv
    const body = value.slice(0, -1);
    const dv = value.slice(-1);

    if (value.length === 1) return value;

    // Format body with dots
    let formattedBody = '';
    for (let i = body.length - 1, j = 0; i >= 0; i--, j++) {
        if (j > 0 && j % 3 === 0) {
            formattedBody = '.' + formattedBody;
        }
        formattedBody = body[i] + formattedBody;
    }

    return `${formattedBody}-${dv}`;
};

/**
 * Formats a Phone Number to Chile Standard (+56 9 XXXX XXXX)
 * @param {string} phone
 * @returns {string} Formatted Phone
 */
export const formatPhone = (phone) => {
    if (!phone) return '';

    // Keep only digits
    let digits = phone.replace(/\D/g, '');

    if (digits.length === 0) return '';

    // Helper to format 8 digits as XXXX XXXX
    const format8 = (str) => {
        return `${str.slice(0, 4)} ${str.slice(4)}`;
    };

    // Case: 8 digits (standard local mobile entered) -> Prepend +56 9
    // Example: 78644790 -> +56 9 7864 4790
    if (digits.length === 8) {
        return `+56 9 ${format8(digits)}`;
    }

    // Case: 9 digits (starts with 9) -> Prepend +56
    // Example: 978644790 -> +56 9 7864 4790
    if (digits.length === 9 && digits.startsWith('9')) {
        return `+56 9 ${format8(digits.slice(1))}`;
    }

    // Case: 11 digits (starts with 569) -> Format spacing
    // Example: 56978644790 -> +56 9 7864 4790
    if (digits.length === 11 && digits.startsWith('569')) {
        return `+56 9 ${format8(digits.slice(3))}`;
    }

    // Other cases: return as is with + if it had it, or just digits?
    // User said "independiente de como uno lo ingrese deben quedar..."
    // If it doesn't match standard lengths, just return +{digits}

    return `+${digits}`;
};
